import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit {
  @Input("showFileScanLoader") showFileScanLoader;
  @Input('showCompleteLoader') showCompleteLoader: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

}
